import { TDashboardComponent } from "MyDashboards/components/ComponentRegistry/types";
import px from "MyDashboards/utils/px";
import React from "react";

import { Element } from "MyDashboards/state/editorTypes";
import { getCurrentGlobalContext } from "qpr-base/context/AppCtxProvider";

/**
 * This component renders a placeholder box in place of the actual element, can be used as default renderer
 */

const getAlignmentFromParagraph = (paragraphAlignment: string) => {
  const { rtl } = getCurrentGlobalContext();
  const alignments: Record<string, string> = {
    left: rtl ? "flex-end" : "flex-start",
    right: rtl ? "flex-start" : "flex-end",
    center: "center",
  };
  return alignments[paragraphAlignment.toLocaleLowerCase()];
};

const thumbNailRender = ({ el }: { el: Element }) => {
  if (!el.paragraphs) {
    return null;
  }
  const AVERAGE_PREVIEW_LINE_HEIGHT = 10;
  const numOfLines =
    Math.floor(el.height / (2 * AVERAGE_PREVIEW_LINE_HEIGHT)) || 0;
  const LINES = new Array(numOfLines).fill(0);
  const LAST_LINE_WIDTH = el.width / 2;

  const isParagraph = el.height > 50;

  if (isParagraph) {
    return (
      <div
        style={{
          height: px(el.height),
          width: px(el.width),
          padding: "20px 10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems:
            getAlignmentFromParagraph(el.paragraphs[0].textAlign as string) ||
            "flex-start",
        }}
      >
        {LINES.map((_, idx) => (
          <div
            style={{
              width: px(idx === LINES.length - 1 ? LAST_LINE_WIDTH : el.width), // to preview text alignment
              height: px(AVERAGE_PREVIEW_LINE_HEIGHT),
              display: "flex",
              justifyContent: "flex-start",
              backgroundColor: "#B7B7B7",
              borderRadius: px(AVERAGE_PREVIEW_LINE_HEIGHT * 0.1),
              flexWrap: "wrap",
              overflow: "hidden",
            }}
          />
        ))}
      </div>
    );
  }
  return (
    <div
      style={{
        backgroundColor: "#B7B7B7",
        width: px(el.width),
        height: px(el.height),
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        borderRadius: px(5),
      }}
    />
  );
};

const PreviewText: TDashboardComponent = {
  editorMode: "text",
  Edit: () => <div />,
  Render: thumbNailRender,
};
export default PreviewText;
